import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const Imprint = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-zinc-950 min-h-screen pt-32 pb-24 px-6">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto"
      >
        <Link 
          to="/" 
          className="text-orange-500 hover:text-orange-400 font-medium mb-12 inline-block transition-colors"
        >
          ← {t.imprint.back}
        </Link>
        
        <h1 className="text-4xl md:text-5xl font-black text-white mb-12 tracking-tighter">
          {t.imprint.title}
        </h1>

        <div className="space-y-10">
          {t.imprint.sections.map((section, index) => (
            <div key={index} className="space-y-2">
              <h2 className="text-zinc-500 font-bold uppercase tracking-widest text-xs">
                {section.label}
              </h2>
              <p className="text-zinc-300 leading-relaxed text-lg whitespace-pre-line">
                {section.value}
              </p>
            </div>
          ))}

          <div className="pt-8 border-t border-white/5 space-y-4">
            <h2 className="text-2xl font-bold text-white tracking-tight">
              {t.imprint.dispute.title}
            </h2>
            <p className="text-zinc-400 leading-relaxed text-lg">
              {t.imprint.dispute.content}
            </p>
          </div>
        </div>

        <div className="mt-20 pt-12 border-t border-white/5">
          <p className="text-zinc-500 text-sm">
            &copy; {new Date().getFullYear()} Mathias Deppe. All rights reserved.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Imprint;